"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _luxon = require("luxon");

var _ = require(".");

var User =
/** @class */
function () {
  function User() {
    this.id = null;
    this.firstName = null;
    this.lastName = null;
    this.email = null;
    this.hash = null;
    this.isSuspended = null;
    this.createdAt = null;
    this.updatedAt = null;
    this.practiceId = null;
    this.practice = null;
    this.forgotPasswordRequests = null;
    this.sessions = null;
    this.tests = null;
    this.lastUsedInstrumentSerialNumber = null;
    this.lastUsedVeterinarianId = null;
    this.lastUsedLabTechId = null;
    this.passwordResetRequired = null;
  }

  User.thaw = function (userObj) {
    var _a, _b;

    if (userObj == null) return null;
    var user = new User();

    if (userObj.id != null) {
      user.setId(userObj.id);
    }

    if (userObj.firstName != null) {
      user.setFirstName(userObj.firstName);
    }

    if (userObj.lastName != null) {
      user.setLastName(userObj.lastName);
    }

    if (userObj.email != null) {
      user.setEmail(userObj.email);
    }

    if (userObj.hash != null) {
      user.setHash(userObj.hash);
    }

    if (userObj.isSuspended != null) {
      user.setIsSuspended(userObj.isSuspended == null ? null : userObj.isSuspended ? true : false);
    }

    if (userObj.createdAt != null) {
      user.setCreatedAt((_a = _luxon.DateTime === null || _luxon.DateTime === void 0 ? void 0 : _luxon.DateTime.fromISO(userObj.createdAt)) !== null && _a !== void 0 ? _a : null);
    }

    if (userObj.updatedAt != null) {
      user.setUpdatedAt((_b = _luxon.DateTime === null || _luxon.DateTime === void 0 ? void 0 : _luxon.DateTime.fromISO(userObj.updatedAt)) !== null && _b !== void 0 ? _b : null);
    }

    if (userObj.practiceId != null) {
      user.setPracticeId(userObj.practiceId);
    }

    if (userObj.practice != null) {
      user.setPractice(_.Practice.thaw(userObj.practice));
    }

    if (userObj.lastUsedInstrumentSerialNumber != null) {
      user.setLastUsedInstrumentSerialNumber(userObj.lastUsedInstrumentSerialNumber);
    }

    if (userObj.lastUsedVeterinarianId != null) {
      user.setLastUsedVeterinarianId(userObj.lastUsedVeterinarianId);
    }

    if (userObj.lastUsedLabTechId != null) {
      user.setLastUsedLabTechId(userObj.lastUsedLabTechId);
    }

    if (userObj.forgotPasswordRequests != null) {
      user.setForgotPasswordRequests(_.ForgotPasswordRequest.thawList(userObj.forgotPasswordRequests));
    }

    if (userObj.sessions != null) {
      user.setSessions(_.Session.thawList(userObj.sessions));
    }

    if (userObj.tests != null) {
      user.setTests(_.Test.thawList(userObj.tests));
    }

    if (userObj.passwordResetRequired != null) {
      user.setPasswordResetRequired(userObj.passwordResetRequired == null ? null : userObj.passwordResetRequired ? true : false);
    }

    return user;
  };

  User.thawList = function (userObjList) {
    if (userObjList == null) {
      return [];
    }

    var users = [];

    for (var i = 0; i < userObjList.length; i++) {
      users.push(User.thaw(userObjList[i]));
    }

    return users;
  };

  User.freeze = function (user) {
    var _a, _b, _c, _d;

    if (user == null) {
      return null;
    }

    var userObj = {};

    if (user.getId() != null) {
      userObj.id = user.getId();
    }

    if (user.getFirstName() != null) {
      userObj.firstName = user.getFirstName();
    }

    if (user.getLastName() != null) {
      userObj.lastName = user.getLastName();
    }

    if (user.getEmail() != null) {
      userObj.email = user.getEmail();
    }

    if (user.getHash() != null) {
      userObj.hash = user.getHash();
    }

    if (user.getIsSuspended() != null) {
      userObj.isSuspended = user.getIsSuspended() == null ? null : user.getIsSuspended() ? 1 : 0;
    }

    if (user.getCreatedAt() != null) {
      userObj.createdAt = (_b = (_a = user.getCreatedAt()) === null || _a === void 0 ? void 0 : _a.toISO()) !== null && _b !== void 0 ? _b : null;
    }

    if (user.getUpdatedAt() != null) {
      userObj.updatedAt = (_d = (_c = user.getUpdatedAt()) === null || _c === void 0 ? void 0 : _c.toISO()) !== null && _d !== void 0 ? _d : null;
    }

    if (user.getPracticeId() != null) {
      userObj.practiceId = user.getPracticeId();
    }

    if (user.getPractice() != null) {
      userObj.practice = _.Practice.freeze(user.getPractice());
    }

    if (user.getForgotPasswordRequests() != null) {
      userObj.forgotPasswordRequests = _.ForgotPasswordRequest.freezeList(user.getForgotPasswordRequests());
    }

    if (user.getSessions() != null) {
      userObj.sessions = _.Session.freezeList(user.getSessions());
    }

    if (user.getTests() != null) {
      userObj.tests = _.Test.freezeList(user.getTests());
    }

    if (user.getLastUsedInstrumentSerialNumber() != null) {
      userObj.lastUsedInstrumentSerialNumber = user.getLastUsedInstrumentSerialNumber();
    }

    if (user.getLastUsedVeterinarianId() != null) {
      userObj.lastUsedVeterinarianId = user.getLastUsedVeterinarianId();
    }

    if (user.getLastUsedLabTechId() != null) {
      userObj.lastUsedLabTechId = user.getLastUsedLabTechId();
    }

    if (user.getPasswordResetRequired() != null) {
      userObj.passwordResetRequired = user.getPasswordResetRequired() == null ? null : user.getPasswordResetRequired() ? 1 : 0;
    }

    return userObj;
  };

  User.freezeList = function (users) {
    if (users == null) {
      return [];
    }

    var userObjList = [];

    for (var i = 0; i < users.length; i++) {
      userObjList.push(User.freeze(users[i]));
    }

    return userObjList;
  };
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  User.prototype.setId = function (id) {
    this.id = id;
  };

  User.prototype.setFirstName = function (firstName) {
    this.firstName = firstName;
  };

  User.prototype.setLastName = function (lastName) {
    this.lastName = lastName;
  };

  User.prototype.setEmail = function (email) {
    this.email = email;
  };

  User.prototype.setHash = function (hash) {
    this.hash = hash;
  };

  User.prototype.setIsSuspended = function (isSuspended) {
    this.isSuspended = isSuspended;
  };

  User.prototype.setCreatedAt = function (createdAt) {
    this.createdAt = createdAt;
  };

  User.prototype.setUpdatedAt = function (updatedAt) {
    this.updatedAt = updatedAt;
  };

  User.prototype.setPracticeId = function (practiceId) {
    this.practiceId = practiceId;
  };

  User.prototype.setPractice = function (practice) {
    this.practice = practice;
  };

  User.prototype.setForgotPasswordRequests = function (forgotPasswordRequests) {
    this.forgotPasswordRequests = forgotPasswordRequests;
  };

  User.prototype.setSessions = function (sessions) {
    this.sessions = sessions;
  };

  User.prototype.setTests = function (tests) {
    this.tests = tests;
  };

  User.prototype.setLastUsedInstrumentSerialNumber = function (lastUsedInstrumentSerialNumber) {
    this.lastUsedInstrumentSerialNumber = lastUsedInstrumentSerialNumber;
  };

  User.prototype.setLastUsedVeterinarianId = function (lastUsedVeterinarianId) {
    this.lastUsedVeterinarianId = lastUsedVeterinarianId;
  };

  User.prototype.setLastUsedLabTechId = function (lastUsedLabTechId) {
    this.lastUsedLabTechId = lastUsedLabTechId;
  };

  User.prototype.setPasswordResetRequired = function (passwordResetRequired) {
    this.passwordResetRequired = passwordResetRequired;
  };
  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  User.prototype.getId = function () {
    return this.id;
  };

  User.prototype.getFirstName = function () {
    return this.firstName;
  };

  User.prototype.getLastName = function () {
    return this.lastName;
  };

  User.prototype.getEmail = function () {
    return this.email;
  };

  User.prototype.getHash = function () {
    return this.hash;
  };

  User.prototype.getIsSuspended = function () {
    return this.isSuspended;
  };

  User.prototype.getCreatedAt = function () {
    return this.createdAt;
  };

  User.prototype.getUpdatedAt = function () {
    return this.updatedAt;
  };

  User.prototype.getPracticeId = function () {
    return this.practiceId;
  };

  User.prototype.getPractice = function () {
    return this.practice;
  };

  User.prototype.getForgotPasswordRequests = function () {
    return this.forgotPasswordRequests;
  };

  User.prototype.getSessions = function () {
    return this.sessions;
  };

  User.prototype.getTests = function () {
    return this.tests;
  };

  User.prototype.getLastUsedInstrumentSerialNumber = function () {
    return this.lastUsedInstrumentSerialNumber;
  };

  User.prototype.getLastUsedVeterinarianId = function () {
    return this.lastUsedVeterinarianId;
  };

  User.prototype.getLastUsedLabTechId = function () {
    return this.lastUsedLabTechId;
  };

  User.prototype.getPasswordResetRequired = function () {
    return this.passwordResetRequired;
  };
  /* -------------------------
     -------------------------
     -------- HELPERS --------
     -------------------------
     ------------------------- */


  User.prototype.getFullName = function () {
    return this.firstName != null && this.lastName != null ? this.firstName + ' ' + this.lastName : null;
  };

  return User;
}();

var _default = User;
exports.default = _default;